import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { View, Text } from 'react-native';
import withTheme from '../../../Theme/withTheme';

import { Menu, MenuItem, Ripple, Icon, IconButton } from '../../../';
import styles from './DataTablePagination.styles';

class DataTablePagination extends Component {
  static propTypes = {
    children: PropTypes.node,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    onChangePage: PropTypes.func,
    numberOfPages: PropTypes.number,
    numberOfRows: PropTypes.number,
    page: PropTypes.number,
    perPage: PropTypes.number,
    possibleNumberPerPage: PropTypes.number,
    onChangeRowsPerPage: PropTypes.func,
  };

  state = { visible: false };

  _handleChangeRowsPerPage(item) {
    const { onChangeRowsPerPage } = this.props;
    this.setState({ visible: false });
    onChangeRowsPerPage(item);
  }

  _renderPossiblePagesPerRow() {
    const { possibleNumberPerPage } = this.props;
    let rows = possibleNumberPerPage ? possibleNumberPerPage : [2, 5, 10, 15];

    return rows.map(item => (
      <MenuItem
        key={item}
        text={item}
        onPress={() => this._handleChangeRowsPerPage(item)}
      />
    ));
  }
  _renderRowsPerPage() {
    const { perPage } = this.props;
    const { visible } = this.state;

    return (
      <View style={styles.rowsPerPage}>
        <Text
          style={[styles.footerFont, styles.rowsPerPageText]}
          numberOfLines={1}>
          {'Rows Per Page:'}
        </Text>
        <Menu
          visible={visible}
          button={
            <Ripple
              onPress={() => this.setState({ visible: true })}
              style={styles.menuButton}>
              <Text style={styles.footerFont}>{perPage}</Text>
              <Icon
                name={'arrow-drop-down'}
                size={24}
                color={'rgba(33, 33, 33, 0.6)'}
              />
            </Ripple>
          }>
          {this._renderPossiblePagesPerRow()}
        </Menu>
      </View>
    );
  }

  _renderCurrentPage() {
    const { page, perPage, numberOfRows } = this.props;
    const startRange = numberOfRows === 0 ? 0 : page * perPage + 1;
    const endRange = Math.min(numberOfRows, (page + 1) * perPage);

    return (
      <Text
        style={[
          styles.footerFont,
          styles.currentNumber,
        ]}>{`${startRange}-${endRange} of ${numberOfRows} `}</Text>
    );
  }

  _renderNavigation() {
    const { page, numberOfPages, onChangePage } = this.props;
    return (
      <Fragment>
        <IconButton
          name={'chevron-left'}
          disabled={page === 0}
          onPress={() => onChangePage(page - 1)}
          size={24}
          style={{ marginRight: 24 }}
          color={page === 0 ? 'rgba(33, 33, 33, 0.3)' : 'rgba(0, 0, 0, 0.54)'}
        />
        <IconButton
          name={'chevron-right'}
          disabled={page === numberOfPages - 1}
          onPress={() => onChangePage(page + 1)}
          size={24}
          color={
            page === numberOfPages - 1
              ? 'rgba(33, 33, 33, 0.3)'
              : 'rgba(0, 0, 0, 0.54)'
          }
        />
      </Fragment>
    );
  }

  render() {
    const { style } = this.props;

    return (
      <View style={[styles.container, style]}>
        {this._renderRowsPerPage()}
        {this._renderCurrentPage()}
        {this._renderNavigation()}
      </View>
    );
  }
}

export default withTheme(DataTablePagination);
